<template>
  <div class="jumbotron">
    <div class="login-container">
      <div class="row justify-content-md-center">
        <div class=" col-sm-6 col-lg-4">
          <div v-if="alert.message" :class="`alert ${alert.type}`">{{alert.message}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6 col-lg-4 offset-lg-4 mb-4">
          <div class="panel panel-login">
            <div class="panel-heading" style="padding-top: 1em;">
              <div class="row">
                <div class="col-12">
                  <a href="#" class="active" id="verify-form-link">{{$t('authenticate.verify')}}</a>
                </div>
              </div>
              <hr>
            </div>
            <div class="panel-body" style="padding: 1em;">
              <div class="row">
                <div class="col-lg-12">
                  <form @submit.prevent="handleSubmitVerify" data-vv-scope="form-verify" id="verify-form" style="display: block;">
                    <div class="form-group">
                      <label htmlFor="code">{{ $t('authenticate.code') }}</label>
                      <input id="verify-text" type="text" v-model="code" v-validate="{ required: true, min: 5 }" name="code" class="form-control" :class="{ 'is-invalid': submitted && errors.has('code') }" :data-vv-as="$t('authenticate.code')"/>
                      <div v-if="submitted && errors.has('code')" class="invalid-feedback">{{ errors.first('code') }}</div>
                    </div>
                    <div class="form-group">
                      <div class="d-flex" style="align-items: center">
                        <span v-if="countdown > 0" class="ml-4" :class="{ 'timeout-soon': countdown < 30 }">{{countdown | timeformat}}</span>
                        <a v-if="countdown === 0 && hasReqData" class="ml-4" href="#" @click="resend()">{{$t("login.resend_sms")}}</a>
                        <img v-show="status.authenticating" class="mr-auto ml-2" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                        <button class="mr-auto btn btn-primary">{{ $t('authenticate.verify') }}</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from 'config'
import VueAgile from 'vue-agile/src/Agile.vue'
/* eslint-disable */
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    'agile': VueAgile
  },
  data () {
    return {
      retryTimes: 2,
      countdown: 0,
      code: '',
      submitted: false,
      slickOptions: {
        arrows: false,
        dots: true
      },
      unsubscribe: null
    }
  },
  computed: {
    ...mapState('account', ['status']),
    ...mapState({
      alert: state => state.alert,
      hasReqData: state => state.account.loginData || state.account.registerData
    })
  },
  created () {
    this.checkShowVerify()
    this.countdown = config.verifyCountDown

    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'account/loginSuccess' ||
          mutation.type === 'account/registerSuccess') {
        this.checkShowVerify()
        this.countdown = config.verifyCountDown
        if (this.retryTimes === 0) {
          this.clearLoginOrRegister()
        }
      }
    })
  },
  mounted () {
    /* this.$loadStyle("https://unpkg.com/persian-datepicker@latest/dist/css/persian-datepicker.min.css")
    this.$loadScript("https://code.jquery.com/jquery-3.3.1.min.js")
    this.$loadScript("https://unpkg.com/persian-date@latest/dist/persian-date.min.js")
    this.$loadScript("https://unpkg.com/persian-datepicker@latest/dist/js/persian-datepicker.min.js") */
    //$("#birthdate-text").pDatepicker();

    $('body').addClass('loaded');
  },
  destroyed () {
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  },
  watch: {
    countdown: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.countdown--
          }, 1000)
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('account', ['authenticate', 'checkShowVerify', 'resendLoginOrRegister', 'clearLoginOrRegister']),
    ...mapActions({
      clearAlert: 'alert/clear'
    }),
    handleSubmitVerify (e) {
      this.submitted = true
      this.$validator.validateAll('form-verify').then(valid => {
        if (valid) {
          const { code } = this
          if (code) {
            this.authenticate({ code })
          }
        }
      })
    },
    resend() {
      this.retryTimes--
      this.resendLoginOrRegister()
    }
  }
}
</script>

<style>
.timeout-soon{
  color: darkorange;
}
#verify-text {
  text-align: center;
  letter-spacing: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/VerifyCode.vue